import { edisSummaryDetails } from "../../apis/transactional";
import { generateTpin } from "../../apis/nontransactional";
import { EDIS } from "../actionTypes";
import { toastConfig } from "./toast";
import { GENERATE_TPIN_FAILURE_TEXT, GENERATE_TPIN_TEXT } from "../../utils/global_variables";

export const getEDISSummaryDetails = (payload) => async (dispatch) => {
    const objResponse = await edisSummaryDetails(payload);
    if (objResponse.status) {
        dispatch(getEDISSummaryDetailsSuccess(objResponse.data.data));
    }
    else {
        dispatch(getEDISSummaryDetailsFailure({}));
    }
};

export const getEDISSummaryDetailsSuccess = (payload) => {
    return { type: EDIS.EDIS_SUMMARY_DETAILS_SUCCESS, payload };
};

export const getEDISSummaryDetailsFailure = (payload) => {
    return { type: EDIS.EDIS_SUMMARY_DETAILS_FAILURE, payload };
};

export const submitDetailsForEdis = (payload) => async (dispatch) => {
    // console.log("submit method called", payload);
};

export const getTpin = (payload) => async (dispatch) => {
    const objResponse = await generateTpin(payload);
    if (objResponse.status) {
        dispatch(generateTpinSuccess(objResponse.data));
        dispatch(toastConfig({
            autoDismiss: false,
            show: true,
            message: GENERATE_TPIN_TEXT
            ,
            button: [{
                btnName: "OK",
                className: 'btn btn-solid ms-3',
                onClickHandler: ()=>{
                    dispatch(toastConfig({show:false}))
                }
            }]
        }));
    }
    else {
        dispatch(generateTpinFailure(null));
        dispatch(toastConfig({
            autoDismiss: false,
            show: true,
            message: GENERATE_TPIN_FAILURE_TEXT
        }));
    }
};

export const generateTpinSuccess = (payload) => {
    return { type: EDIS.GENERATE_TPIN_SUCCESS, payload };
};

export const generateTpinFailure = (payload) => {
    return { type: EDIS.GENERATE_TPIN_FAILURE, payload };
};

// Ajitesh : 04/01/2024: BT-109135: Breeze eDIS implementation loader action for grid - Start
export const updateEdisIsLoading = (payload) => {
    return { type: EDIS.UPDATE_EDIS_IS_LOADING, payload };
};
// Ajitesh : 04/01/2024: BT-109135: Breeze eDIS implementation loader action for grid - End
